import React, { Fragment, useContext, useRef, useState } from 'react'
import { Alert } from 'react-bootstrap';

import useTxSender from '../hooks/useTxSender.js';
import useLog from "../hooks/useLog.js"

import SkeletonText from '../components/SkeletonText.js';
import { UserContext } from "../Contexts/UserContext/UserContext.js";
import { Slide } from "../display_wallet.js"
import { Row } from "../components/Row";
import { Spaces } from "../components/Spaces";
import RowWithTitle from "../components/RowWithTitle"
import { TextDisplay } from "../components/TextDisplay/TextDisplay";
import { forceFloat } from "../helpers/helpers.js"
import { toFixedDown } from '../helpers/convert_bsv_tokens.js'
import Bold from "../components/Bold.js"
import SuccessTxSender from '../components/SuccessTxSender.js';
import { default_func_jsx_fail } from '../helpers/helpers.js';
import SoldeToken from '../components/SoldeToken.js';
// import TxStateContext from '../Contexts/TxStateContext.js';



export default function Slide_MintTokens(props) {
	const userContext = useContext(UserContext)
	const log = useLog("Slide_MintTokens: ")

	// --- VARS ---

	const coinprops = userContext.get_selected_coin_props()
	const tokenID = coinprops.tokenid
	const tokenName = coinprops.name

	const tokenActionID = tokenID + "_mint" // or mint_delphe ?
	const mess_default = "" //"Un récapitulatif des "+tokenName+" à minter va s'afficher ici"

	// state & refs
	const [nbtomint, set_nbtomint] = useState("")
	const ref_messageEndRef = useRef(null) // for autoscroll

	const array_bool_user_inputs = [
		Boolean(nbtomint && nbtomint > 0),
	]

	const token_balance = userContext.tokens_balance[tokenID]
	const bool_context_has_loaded = (token_balance != null) // && (context.bsvprice !=null)

	// const txStateContext = useContext(TxStateContext) // necessary for slide to update when status updates


	// --- FUNCTIONS ---

	async function func_empty_fields() {
		set_nbtomint("")
	}

	var jsx_loading = null //<LoaderWithMess mess={mess_default} />
	var jsx_recap = null

	// we add each field one by one
	if (nbtomint && nbtomint > 0) {
		jsx_recap = <Fragment>
			Effectuer un mint de {nbtomint} {tokenName}<br />
		</Fragment>
	}

	const jsx_sending = <Fragment>
		Mint en cours de {nbtomint} {tokenName}...&nbsp;
		<i className="reloadIcon fas fa-sync fa-spin" />
	</Fragment>


	const func_jsx_success = (txstate) => {
		return (
			<SuccessTxSender txstate={txstate}>
				{txstate.nbtokens} {tokenName} mintés avec succès !
			</SuccessTxSender>
		)
	}

	// --- HOOK useTxSender ---

	const [
		bool_broadcast_lock,
		func_resetMess,
		dict_sendbutton_style,
		jsx_mess,
	]
		= useTxSender(
			tokenActionID,
			array_bool_user_inputs,
			bool_context_has_loaded,
			ref_messageEndRef,
			mess_default,
			jsx_loading,
			jsx_recap,
			jsx_sending,
			func_jsx_success,
			default_func_jsx_fail,
			func_empty_fields,
		)


	// --- VARS ---

	const ownerIsAdmin = userContext.ownerIsAdmin
	const tokensupply = userContext.tokensupply


	// --- FUNCTIONS ---

	const handleChangeVal = (event) => {
		if (bool_broadcast_lock) return // don't allow edit during sending
		func_resetMess()

		var val = event.target.value
		val = val.toString().replace(/[^0-9.,]/g, "");
		val = forceFloat(val, 2)

		set_nbtomint(val)
	}

	const handleClick = async (event) => {
		event.preventDefault() // prevent redirection
		if (!bool_broadcast_lock) {
			// async but we don't want to await here !
			userContext.mint_tokens(nbtomint)
		}
	}


	// --- DISPLAY ---

	var jsx_isAdminMess = null
	if (ownerIsAdmin) {

		var loading_mess = <SkeletonText width="4em" black />
		var supplyTokens = loading_mess
		if (tokensupply && !isNaN(tokensupply)) {
			supplyTokens = toFixedDown(parseFloat(tokensupply), 2)
		}

		jsx_isAdminMess =
			<Alert variant="warning">
				<i style={{ fontSize: "25px", marginRight: "10px" }} className="fa fa-info-circle" />
				Portefeuille administrateur détecté. <br /><br />

				Quantité de {tokenName} sur ce wallet:&nbsp;
				<Bold> {token_balance || loading_mess} </Bold> <br />

				Quantité totale de {tokenName} en circulation:&nbsp;
				<Bold> {supplyTokens} </Bold>
			</Alert>
	}

	log("\n nbtomint = ", nbtomint,
		"\n bool_broadcast_lock=", bool_broadcast_lock,
		// "\n func_resetMess=", func_resetMess,
		// "\n jsx_mess=", jsx_mess
	)


	return (
		<Slide num={props.num}>

			<h1><i className="fas fa-cube" /><Spaces count="3" />
				Mint {tokenName}
			</h1>
			<br />

			{jsx_isAdminMess ?
				jsx_isAdminMess
				:
				<Alert variant="danger">
					<Bold>Vous ne semblez pas être l'administrateur de ce token.</Bold>
				</Alert>
			}
			<br />

			<center>
				<SoldeToken />
				<br />
			</center>

			<RowWithTitle title={<Fragment>
				Amount of {tokenName} to mint
			</Fragment>}>
				<input value={nbtomint}
					onChange={handleChangeVal} type='number'
					id='token_number_mint' min="0" step="1" placeholder="100.25" className='item' />
			</RowWithTitle>

			<center>
				<div ref={ref_messageEndRef}>
					{jsx_mess ?
						<Row><TextDisplay>
							{jsx_mess}
						</TextDisplay></Row>
						: null}
				</div>
			</center>

			<Row>
				<button style={dict_sendbutton_style} onClick={handleClick}
					id='button_mint_tokens' className="submitbutton">
					Mint {nbtomint ? nbtomint : ""} {tokenName}
				</button>
			</Row>

		</Slide>
	)
}
